import { v4 as uuidv4 } from 'uuid'
import { getDebugModeSavedPref } from '../debug/debugModeUtils'
import { AppState } from './AppState'
import { UserType } from '../types/userTypes'
import { BuildConfig } from '../config/BuildConfig'
import { ProductSeries } from '../types/productTypes'
import { WholesalerEntryPointProSeries } from '../wholesaler-integration/EntryPoints'

const { DefaultListName } = BuildConfig.brand.copy

export const DefaultListState = {
  configuredProducts: [],
  rooms: [],
  listName: DefaultListName,
  hasListBeenShown: false,
}

export function getDefaultAppState(): Readonly<AppState> {
  return {
    userState: {
      ...DefaultListState,
      listId: uuidv4(),
      moreInfo: false,
      wallColor: 'rgb(255, 255, 255)',
      renameListTutorialDismissed: false,
      typeSelectorTutorialDismissed: false,
      customiseHintShownCount: 0,
      userType: null,
      selectedProductSeries: null,
      isAuthenticated: false
    },
    screen: null,
    editingProductId: uuidv4(),
    isEditing: false,
    focusedListItemUid: null,
    debugMode: getDebugModeSavedPref(),
    showCashSales: false,
    optionalWiserMode: null,
    hasOptedOutOfWiserHubPrompt: false,
    hasOptedOutOfMomentarySwitchesPrompt: false,
  }
}

export function getDefaultWholesalerAppState(entryPoint: string | null): Readonly<AppState> {
  const base = getDefaultAppState()

  const selectedProductSeries = entryPoint === WholesalerEntryPointProSeries ? ProductSeries.Pro : ProductSeries.Iconic

  return {
    ...base,
    userState: {
      ...base.userState,
      userType: UserType.Electrician,
      selectedProductSeries,
      renameListTutorialDismissed: true,
    },
  }
}

export function getDefaultClipspecAppState(): Readonly<AppState> {
  const base = getDefaultAppState()

  return {
    ...base,
    userState: {
      ...base.userState,
      userType: UserType.Electrician,
      selectedProductSeries: ProductSeries.Iconic,
      renameListTutorialDismissed: true,
    },
  }
}
